var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-table-column", {
    attrs: {
      label: _vm.label,
      prop: _vm.prop,
      "class-name": "action-type-name",
      sortable: _vm.sortable
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(scope) {
          return [
            _c(
              "el-tag",
              {
                attrs: {
                  type: _vm.actionTypeColor(scope.row.action_type_name),
                  "disable-transitions": ""
                }
              },
              [_vm._v(" " + _vm._s(scope.row.action_type_name) + " ")]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }